const API_BASE_URL = process.env.REACT_APP_API_URL || '';

export const API_ENDPOINTS = {
  AUTH: `${API_BASE_URL}/api/auth`,
  REQUESTS: `${API_BASE_URL}/api/requests`,
  DRIVERS: `${API_BASE_URL}/api/drivers`,
  ADMIN: `${API_BASE_URL}/api/admin`,
  SMS: `${API_BASE_URL}/api/sms`,
  OFFERS: `${API_BASE_URL}/api/offers`,
  CONTACT: `${API_BASE_URL}/api/contact`,
  RATINGS: `${API_BASE_URL}/api/ratings`,
  BILLING: `${API_BASE_URL}/api/billing`,
  ADDRESSES_AUTOCOMPLETE: `${API_BASE_URL}/api/addresses/autocomplete`,
  ADDRESSES_VALIDATE: `${API_BASE_URL}/api/addresses/validate`,
  CONFIG: `${API_BASE_URL}/api/config`,
};

export default API_BASE_URL;
